import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import getValues from '@/app/[locale]/membership/utils/getValues';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

const values = getValues();

const MembershipYourHealth = (): JSX.Element => {
  const t = useTranslations();
  //TODO: GROW-1607 clean up Gen3 clean up
  const OR4Enabled = useOuraGen4Enabled();

  return (
    <section
      className="relative pb-20 md:px-5 lg:pb-24 lg:pt-12"
      data-cy="membership-your-health"
    >
      <LayoutGrid className="h-full content-between">
        <GridItem
          className="relative mb-6 mt-2 flex items-center justify-between md:mb-20"
          colStart={{ sm: 'full', md: 3, lg: 3 }}
          colEnd={{ sm: 'full', md: 13, lg: 13 }}
          rowStart={{ sm: 3, md: 2 }}
          rowEnd={{ sm: 3, md: 2 }}
        >
          <div className="relative aspect-[125/157] w-full">
            <ArtDirectionImage
              srcSet={[
                {
                  src: OR4Enabled
                    ? t('membership_complete_health_app_img')
                    : 'membership/5050-img-m2x',
                  media: '(max-width: 767px)',
                },
                {
                  src: OR4Enabled
                    ? t('membership_complete_health_app_img')
                    : 'membership/5050-img@2x',
                  media: '(min-width: 768px)',
                },
              ]}
              alt={t('membership_your_health_alt')}
              sizes="(max-width: 767px) 100vw, 50vw"
              fill
              className="object-cover"
            />
          </div>
        </GridItem>
        <GridItem
          className="relative mb-6 mt-2 flex flex-col items-center justify-center md:mb-20"
          colStart={{ sm: 'main', md: 14, lg: 15 }}
          colEnd={{ sm: 'main', md: 23, lg: 23 }}
          rowStart={{ sm: 2, md: 2 }}
          rowEnd={{ sm: 2, md: 2 }}
        >
          <TypographyV3
            Element="h2"
            variant="h3"
            className="pb-6 text-5xl"
            data-cy="membership-your-health-title"
          >
            {t('membership_your_health_title')}
          </TypographyV3>
          <TypographyV3 className="text-base">
            {t.rich('membership_your_health_body_site_redesign', values)}
          </TypographyV3>
        </GridItem>
        <GridItem
          colStart={{ sm: 'main', lg: 8 }}
          colEnd={{ sm: 'main', lg: 23 }}
          rowStart={{ sm: 4 }}
          rowEnd={{ sm: 4 }}
        >
          <TypographyV3
            variant="h3"
            className="text-3xl lg:text-5xl"
            height="tight"
          >
            {t('membership_your_health_bottom')}
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MembershipYourHealth;
